import {
  Alert,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import { checkTaskForPlugin, generateForPlugin } from "api/generations.api";
import { BaseInput } from "components/forms/tags/BaseInput";
import { Timer } from "components/info/Timer";
import { AppState } from "index";
import React, { useContext, useEffect, useState } from "react";
import { ParamsForPlugin, PluginResponse } from "types/tags.types";

export function GeneratePlugin() {
  const state = useContext(AppState);
  const [subjenre, setSubjenre] = useState<string>("default");
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<PluginResponse | null>(null);
  const [waitingSeconds, setWaitingSeconds] = useState<number>(0);
  const [progress, setProgress] = useState<number>(0);

  const startStatuses = () => {
    setIsLoading(true);
    setError(null);
    setResult(null);
    handleActiveTimer(true);
    setWaitingSeconds(0);
    setProgress(0);
  };

  const checkTask = async (task_id: string) => {
    try {
      const response = await checkTaskForPlugin(task_id);
      if ("error" in response) {
        throw Error(response.error);
      }

      if (!response.data) {
        setIsLoading(true);
        return;
      }

      if (response.data.waiting_seconds || response.data.waiting_seconds === 0) {
        setWaitingSeconds(response.data.waiting_seconds);
      }

      if (response.data.progress) {
        setProgress(response.data.progress);
      }

      if (!response.data.ready) {
        return;
      } else {
        setResult(response.data);
        setIsLoading(false);
        return true;
      }
    } catch (error: any) {
      setIsLoading(false);
      return true;
    }
  };

  const getResult = async (task_id: string) => {
    const isRes = await checkTask(task_id);
    if (isRes) {
      setIsLoading(false);
      handleActiveTimer(false);
      return;
    }

    setTimeout(() => {
      getResult(task_id);
    }, 5000);
  };

  const handleClick = async () => {
    startStatuses();
    const params: ParamsForPlugin = {
      key: state.selectedTagSetSettings.value.key,
      scale: state.selectedTagSetSettings.value.scale,
      bpm:
        state.selectedTagSetSettings.value.bpm === 0
          ? 120
          : state.selectedTagSetSettings.value.bpm,
      subgenre: subjenre,
      genre: "dev",
    };
    const res = await generateForPlugin(params);

    if (res.error) {
      setError(res.error);
      setIsLoading(false);
    }

    await getResult(res.task_id);
  };

  const handleChangeSubjenre = (e: SelectChangeEvent) => {
    // setSubjenre(Number(e.target.value));
    setSubjenre(e.target.value);
  };

  const handleActiveTimer = (value: boolean) => {
    setIsActive(value);
  };
  return (
    <>
      <Stack direction="row" spacing={4} alignItems="end">
        <BaseInput name="Поджанр" idDisabled={false}>
          <Select value={subjenre} onChange={handleChangeSubjenre}>
            {state.subgenres.value.map((name, idx) => (
              <MenuItem key={idx} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </BaseInput>
        <Timer isActive={isActive}></Timer>
        <Button
          disabled={isLoading}
          variant="contained"
          title="Сгенерировать для плагина"
          onClick={handleClick}
        >
          {isLoading ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <CircularProgress />
              <Typography>Loading...</Typography>
            </Stack>
          ) : (
            <Typography>Сгенерировать для плагина</Typography>
          )}
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Button>
      </Stack>
      <Stack direction={"row"} gap={2}>
        <Typography variant="body2">Прогресс: {progress} / 100</Typography>
        <Typography variant="body2">Время ожидания: {waitingSeconds} с.</Typography>
      </Stack>
      {result ? (
        <Alert>
          <Typography variant="body2">
            full_midi: <a href={result.full_midi || "#"}>{result.full_midi}</a>
          </Typography>
          <Typography variant="body2">
            full_soundbank:{" "}
            <a href={result.full_soundbank || "#"}>{result.full_soundbank}</a>
          </Typography>

          <Typography variant="body2">previews:</Typography>
          {result.previews.map((preview, idx) => (
            <Stack key={idx} direction="row" spacing={1}>
              <Typography variant="body2">
                {preview.name}: <a href={preview.url}>{preview.url}</a>
              </Typography>
            </Stack>
          ))}
          <Typography variant="body2">
            {JSON.stringify(result.filters)}
          </Typography>
        </Alert>
      ) : null}
    </>
  );
}
